import React, { useState } from 'react';
import { format, subDays, startOfMonth } from 'date-fns';
import { es } from 'date-fns/locale';
import { CalendarIcon } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '../../ui/popover';
import { Calendar } from '../../ui/calendar';

const todayUTC = () => {
  const n = new Date();
  return new Date(n.getUTCFullYear(), n.getUTCMonth(), n.getUTCDate());
};

export const toISODate = (d) => format(d, 'yyyy-MM-dd');

export const PRESETS = [
  { key: 'today', label: 'Hoy', range: () => ({ from: todayUTC(), to: todayUTC() }) },
  { key: '7d', label: '7 días', range: () => ({ from: subDays(todayUTC(), 6), to: todayUTC() }) },
  { key: '30d', label: '30 días', range: () => ({ from: subDays(todayUTC(), 29), to: todayUTC() }) },
  { key: '90d', label: '90 días', range: () => ({ from: subDays(todayUTC(), 89), to: todayUTC() }) },
  { key: 'month', label: 'Este mes', range: () => ({ from: startOfMonth(todayUTC()), to: todayUTC() }) },
];

export const DateRangeFilter = ({ value, preset, onChange }) => {
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState(value);

  const label = value?.from
    ? `${format(value.from, 'd MMM yyyy', { locale: es })} – ${format(value.to || value.from, 'd MMM yyyy', { locale: es })}`
    : 'Elegir fechas';

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="search-date-filter">
      <div className="flex bg-gray-900 rounded-lg p-1 ring-1 ring-gray-700">
        {PRESETS.map(p => (
          <button key={p.key} onClick={() => onChange(p.range(), p.key)} data-testid={`date-preset-${p.key}`}
            className={`px-3 py-1.5 rounded-md text-xs font-medium transition-colors ${preset === p.key ? 'bg-orange-500 text-white' : 'text-gray-400 hover:text-white'}`}>
            {p.label}
          </button>
        ))}
      </div>
      <Popover open={open} onOpenChange={(o) => { setOpen(o); if (o) setDraft(value); }}>
        <PopoverTrigger asChild>
          <button data-testid="date-range-trigger"
            className={`inline-flex items-center gap-2 px-3 py-2 rounded-lg text-xs font-medium ring-1 transition-colors ${preset === 'custom' ? 'bg-orange-500/15 text-orange-300 ring-orange-500/40' : 'bg-gray-900 text-gray-300 ring-gray-700 hover:text-white'}`}>
            <CalendarIcon className="w-4 h-4" /> {label}
          </button>
        </PopoverTrigger>
        <PopoverContent align="end" className="w-auto p-0 bg-white" data-testid="date-range-popover">
          <Calendar mode="range" numberOfMonths={2} selected={draft} onSelect={setDraft} locale={es}
            defaultMonth={draft?.from} disabled={{ after: todayUTC() }} initialFocus />
          <div className="flex justify-end gap-2 p-3 border-t">
            <button onClick={() => setOpen(false)} className="px-3 py-1.5 text-xs text-gray-600 hover:text-gray-900" data-testid="date-range-cancel">Cancelar</button>
            <button disabled={!draft?.from} data-testid="date-range-apply"
              onClick={() => { onChange({ from: draft.from, to: draft.to || draft.from }, 'custom'); setOpen(false); }}
              className="px-3 py-1.5 text-xs font-semibold rounded-md bg-orange-500 text-white disabled:opacity-50">Aplicar</button>
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
};
